import { addClass, removeClass } from '../support/classes';
import Component from "./Component";

class GravityForm extends Component
{
    constructor(element, props)
    {
        super(element, props);

        this.bindEvents();
    }

    findParent(target, tagName)
    {
        let parent = target.parentNode;

        while (parent.tagName.toLowerCase() !== tagName.toLowerCase())
        {
            parent = parent.parentNode;
        }

        return parent;
    }

    _handleFocus = (e) =>
    {
        const target = e.target;

        if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA')
        {
            return;
        }

        const parent = this.findParent(target, 'li');

        if (parent)
        {
            addClass(parent, 'active');
        }

    }

    _handleBlur = (e) =>
    {
        const target = e.target;

        if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA')
        {
            return;
        }

        const parent = this.findParent(target, 'li');

        if (parent && target.value.trim() === '')
        {
            removeClass(parent, 'active');
        }

    }

    bindEvents()
    {
        this.element.addEventListener('change', this._handleChange, true);
        this.element.addEventListener('focus', this._handleFocus, true);
        this.element.addEventListener('blur', this._handleBlur, true);
    }
}

export default GravityForm;